<div class="modal-header">
  <h1 id="modal-title" class="modal-title">{{ "sphere.switch_language" | translate }}</h1>
  <button type="button" ngbAutofocus class="fs-close-btn right border-0 bg-transparent p-0" (click)="activeModal.dismiss('Cross click')" data-cy="close-success-splash-button" aria-label="close">
    <fa-icon icon="times-circle" class="circle-icon-btn" aria-hidden="true"></fa-icon>
  </button>
</div>
<div class="modal-body">
  <ul class="list-inline language-chooser" role="group" aria-label="languages">
    @for (lang of helperService.languages; track lang) {
      <li class="list-inline-item mr-0">
        <button
          type="button"
          class="bg-transparent language border-0"
          [class.c-white]="appService.activeTheme == 'dark'"
          [class.selected]="user && user.language_code == lang.code"
          (keyup.enter)="performSwitch(lang.code)"
          (click)="performSwitch(lang.code)"
          style="display: flex; flex-direction: column; align-items: center; text-align: center"
        >
          <img [src]="lang.flag_icon" style="height: 60px; object-fit: contain; display: block" aria-hidden="true" alt="{{ lang.translated_name }}" />
          <span style="margin-top: 4px">{{ lang.name }} {{ lang.translated_name ? "(" + lang.translated_name + ")" : "" }}</span>
        </button>
      </li>
    }
  </ul>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
